module.exports = __webpack_public_path__ + "img/w23-b2.b966143e.jpg";